import { NavigationHierarchyDto } from "../types/NavigationHierarchyDto";

export const REQUEST_NAVIGATION = "REQUEST_NAVIGATION";
export const RECEIVE_NAVIGATION = "RECEIVE_NAVIGATION";
export const RELOAD_NAVIGATION = "RELOAD_NAVIGATION";

export interface RequestNavigationAction {
    type: typeof REQUEST_NAVIGATION;
}

export interface ReceiveNavigationAction {
    type: typeof RECEIVE_NAVIGATION;
    navigation: NavigationHierarchyDto;
}

export interface ReloadNavigationAction {
    type: typeof RELOAD_NAVIGATION;
}

export type NavigationActionTypes =
    ReloadNavigationAction |
    RequestNavigationAction |
    ReceiveNavigationAction;